import '@hotwired/turbo-rails';
import * as ActiveStorage from '@rails/activestorage';
import 'trix';
import '@rails/actiontext';

import './controllers';

ActiveStorage.start();
